import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtINR, fmtDate } from "../lib/format";
import { AlertTriangle } from "lucide-react";

const SEV_COLOR = { "High": "#ff433d", "Medium": "#fb8b1e", "Low": "#8892B0" };

export default function Risk() {
    const [data, setData] = useState(null);
    const [sev, setSev] = useState("All");
    useEffect(() => { api.get("/risk/alerts").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING RISK REGISTER...</div>;

    const filtered = data.alerts.filter((a) => sev === "All" || a.severity === sev);

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// RISK & FRAUD DETECTION</div>
                <h1 className="font-display font-black text-3xl">Anomaly Command</h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="risk-total-amt" label="Total Value at Risk" value={data.summary.total_at_risk} sub={`${data.summary.count} alerts`} accent />
                <KpiCard testId="risk-high" label="High Severity" value={data.summary.by_severity.High} format="custom" sub="Immediate action" />
                <KpiCard testId="risk-medium" label="Medium Severity" value={data.summary.by_severity.Medium} format="custom" />
                <KpiCard testId="risk-low" label="Low Severity" value={data.summary.by_severity.Low} format="custom" />
            </div>

            <div className="flex items-center gap-2 font-mono-fin text-[10px] uppercase tracking-wider">
                <span className="text-[var(--text-secondary)]">Severity:</span>
                {["All", "High", "Medium", "Low"].map((s) => (
                    <button
                        key={s}
                        data-testid={`filter-sev-${s.toLowerCase()}`}
                        onClick={() => setSev(s)}
                        className={`px-3 py-1 border ${sev === s ? "border-[var(--brand-amber)] bg-[var(--brand-amber-dim)] text-[var(--text-primary)]" : "border-panel text-[var(--text-secondary)]"}`}
                    >
                        {s}
                    </button>
                ))}
            </div>

            <div className="space-y-2">
                {filtered.map((a) => (
                    <div key={a.id} data-testid={`alert-${a.id}`} className="bg-panel border border-panel p-4 hover:bg-[var(--bg-panel-hover)] transition-colors flex items-start gap-4">
                        <div className={`w-10 h-10 flex items-center justify-center border`} style={{ borderColor: SEV_COLOR[a.severity], color: SEV_COLOR[a.severity] }}>
                            <AlertTriangle size={18} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                                <span className="text-[10px] font-mono-fin uppercase tracking-wider px-1.5 py-0.5 border" style={{ borderColor: SEV_COLOR[a.severity], color: SEV_COLOR[a.severity] }}>{a.severity}</span>
                                <span className="text-[10px] font-mono-fin uppercase tracking-wider text-[var(--text-secondary)]">{a.type}</span>
                                <span className="text-[10px] font-mono-fin uppercase tracking-wider text-[var(--text-muted)]">· Detected {fmtDate(a.detected)}</span>
                            </div>
                            <div className="text-sm text-[var(--text-primary)] mt-1.5 leading-relaxed">{a.description}</div>
                            <div className="text-[10px] font-mono-fin uppercase tracking-wider text-[var(--text-secondary)] mt-1.5">Status: <span className="text-amber">{a.status}</span></div>
                        </div>
                        <div className="text-right shrink-0">
                            <div className="text-[10px] font-mono-fin uppercase tracking-wider text-[var(--text-secondary)]">Impact</div>
                            <div className="font-mono-fin text-lg text-amber">{fmtINR(a.amount)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
